import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { MinesInfoModalComponent } from '@features/mines/modals/mines-info-modal/mines-info-modal.component';

export function provideMinesModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'MinesInfoModalComponent', component: MinesInfoModalComponent }, multi: true },
  ];
}
